import { textNoWhiteSpacesRegex } from "@finway-group/shared/lib/utils/validators"
import { FormInstance, Rule } from "antd/lib/form"

import i18n from "Shared/locales/i18n"
import { countInArray, isNotSet } from "Shared/utils/helper.utils"

import { stringRules } from "Components/forms/rules/common/string.rules"

export const createTaxRules = (formInstance: FormInstance) => ({
    taxRate: [
        {
            validator: (_rule, value: string) => {
                if (isNotSet(value)) {
                    return Promise.reject(new Error(i18n.t("validation:required")))
                }

                if (!textNoWhiteSpacesRegex.test(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space")))
                }

                return Promise.resolve()
            },
        },
        { transform: (v) => Number(v), type: "number", message: i18n.t("validation:numeric") },
        { transform: (v) => Number(v), type: "number", max: 100, message: i18n.t("validation:max.number", { max: 100 }) },
        { transform: (v) => Number(v), type: "number", min: 0, message: i18n.t("validation:min.number", { min: 0 }) },
    ] as Array<Rule>,
    buCode: [
        {
            validator: (_rule, value: number | string) => {
                const buCodes = formInstance.getFieldsValue().taxes.map((e: any) => e.buCode)
                if (countInArray(buCodes, value) >= 2) {
                    return Promise.reject(i18n.t("validation:duplicate", { value: i18n.t("validation:bu_code") }))
                }

                if (value && !textNoWhiteSpacesRegex.test(value.toString())) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space")))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    buCodeName: [stringRules.allowedMultiLineCharsOnly] as Array<Rule>,
})
